// Curated photo avatars sourced from UI Faces (https://uifaces.co/category/human).
// Each entry must be served from this app at /avatars/photos/<filename> so the
// API host allowlist accepts it. Drop the JPEGs into floats-client/public/avatars/photos/.
const photos = Array.from({ length: 31 }, (_, i) => ({
  file: `face-${String(i + 1).padStart(2, "0")}.jpg`,
  credit: "UI Faces",
}));

export default photos;
